<template>
  <div class="odp_mod_line">
    <div class="odp_mod_li_name font-14">{{ lineData["name"] }}：</div>
    <div class="odp_mod_li_right font-14">
      <template v-for="(item, index) in lineData['data_multi']">
        <!-- 下拉块 -->
        <div
          v-if="item.type === 'select'"
          :class="{ odp_mod_li_rig_select: true }"
          :key="item.id"
          :data-index="index"
          @mouseenter="func_vData_selectEnter"
          @mouseleave="func_vData_selectLeave"
           @click="func_vData_selectEnter"
        >
          <div
            :class="{
              odp_mod_li_rig_sel_content: true,
              odp_mod_li_rig_isChoose: item.choose,
            }"
            data-type="data_multi"
            :data-level="item.level"
            :data-index="lineIndex"
            :data-seq="index"
            @click="func_vData_select_click"
          >
            <div class="odp_mod_li_rig_sel_con_name">{{ item.name }}</div>
            <img
              :class="{
                odp_mod_li_rig_sel_con_icon: true,
                odp_mod_li_rig_sel_con_icon_rotate: item.select_show,
              }"
              src="@/assets/icon/arrow_down.png"
            />
          </div>
          <div class="odp_mod_li_rig_list">
            <template v-for="(obj, seq) in item.select_data">
              <div
                :class="{
                  odp_mod_li_rig_li_view: true,
                  odp_mod_li_rig_li_view_show: item.select_show,
                }"
                :key="obj.id"
                data-type="data_multi"
                :data-level="item.level"
                :data-index="lineIndex"
                :data-seq="index"
                :data-select_index="seq"
                @click.stop="func_vData_select_click"
              >
                {{ obj.name }}
              </div>
            </template>
          </div>
        </div>
        <!-- <div
          class="odp_mod_li_rig_isChoose_h5"
          v-if="item.type === 'select'"
          :key="item.id"
          data-type="data"
          :data-index="lineIndex"
          :data-seq="index"
        >
          <template v-for="(obj, seq) in item.select_data">
            <div
              :class="{
                odp_mod_li_rig_li_view_show: true,
                odp_mod_li_rig_li_view_show_h5: obj.choose,
              }"
              :key="obj.id"
              data-type="data_multi"
              :data-index="lineIndex"
              :data-level="item.level"
              :data-seq="index"
              :data-select_index="seq"
              @click="func_vData_select_click_h5"
            >
              {{ obj.name }}
            </div>
          </template>
        </div> -->
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: "vDataMulti",
  props: {
    lineIndex: String,
    lineData: Object,
    func_click: Function,
    func_input: Function,
  },
  data() {
    return {};
  },
  methods: {
    func_vData_selectEnter() {
      const index = event.currentTarget.dataset.index;
      this.lineData["data_multi"][index]["select_show"] = true;
    },
    func_vData_selectLeave() {
      const index = event.currentTarget.dataset.index;
      this.lineData["data_multi"][index]["select_show"] = false;
    },
    func_vData_select_click(event) {
      const index = event.currentTarget.dataset.seq;
      this.lineData["data_multi"][index]["select_show"] = false;
      if (
        !event.currentTarget.dataset.select_index &&
        this.lineData["data_multi"][index]["choose"]
      ) {
        return;
      }
      this.func_click(event);
    },
    // func_vData_select_click_h5(event) {
    //   const index = event.currentTarget.dataset.seq;
    //   const iindex = event.currentTarget.dataset.select_index;
    //   for (let j in this.lineData["data_multi"][1].select_data) {
    //     if (index == 0) {
    //       this.lineData["data_multi"][1].select_data[j].choose = false;
    //       this.lineData["data_multi"][1].select_data[0].choose = true;
    //       // console.log(this.lineData["data_multi"][1])
    //     }
    //   }
    //   for (let i in this.lineData["data_multi"][index].select_data) {
    //     if (i == iindex) {
    //       this.lineData["data_multi"][index].select_data[i].choose = true;
    //     } else {
    //       this.lineData["data_multi"][index].select_data[i].choose = false;
    //     }
    //   }
    //   this.lineData["data_multi"][index]["select_show"] = false;
    //   if (
    //     !event.currentTarget.dataset.select_index &&
    //     this.lineData["data_multi"][index]["choose"]
    //   ) {
    //     return;
    //   }
    //   this.func_click(event);
    // },
  },
  mounted() {},
  beforeMount() {
    for (let s in this.lineData["multi_list"]) {
      this.lineData["multi_list"][s][0].choose = true;
    }
    for (let i in this.lineData["data_multi"][0].select_data) {
      if (
        this.lineData["data_multi"][0].name ==
        this.lineData["data_multi"][0].select_data[i].name
      ) {
        this.lineData["data_multi"][0].select_data[i].choose = true;
      }
    }
    for (let j in this.lineData["data_multi"][1].select_data) {
      if (
        this.lineData["data_multi"][1].name ==
        this.lineData["data_multi"][1].select_data[j].name
      ) {
        this.lineData["data_multi"][1].select_data[j].choose = true;
      }
    }
  },
};
</script>
<style src='@/style/orderProduct.css'></style>
<style src='@/style/orderProduct-h5.css'></style>



// WEBPACK FOOTER //
// src/pages/order/views/vDataMulti.vue